import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IReviewListViewModel, DocDetailsOutput, DocViewOutput, DocPresenterDetails, DocViewAllDetailsOutput, DocPanelCRIOutpu, DocViewInput } from 'src/app/ViewModel/PeerReviewModel';
import { MatDialog } from '@angular/material/dialog';
import { ReviewCreationComponent } from "../review-creation/review-creation.component";
import { ReviewViewComponent } from "../review-view/review-view.component";
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-review-list',
  templateUrl: './review-list.component.html',
  styleUrls: ['./review-list.component.css']
})
export class ReviewListComponent implements OnInit {


  public project_Id!: number ;
  public memberId!: number ;
  public createicon: boolean = false;
  public groupId!: number ;
  public ReviewList: IReviewListViewModel[] = [];
  public app_ReviewList: IReviewListViewModel[] = [];
  public invitation_ReviewList: IReviewListViewModel[] = [];
  public status_ReviewList: IReviewListViewModel[] = [];
  public comments_ReviewList: IReviewListViewModel[] = [];
  public responce_ReviewList: IReviewListViewModel[] = [];
  public impacts_ReviewList: IReviewListViewModel[] = [];
  //public listCount: number;
  public tabname: string = "All";
  public Data: any = {
    ReviewList: [],
    tabname: "",
    Feature: []
  }
  public Feature: any[] = [];
  public enableFilter : boolean = false;
  public data: any[] = [];
  constructor(private _peerReviewService: PeerReviewService, private dialog: MatDialog, private _commonService: CommonService,
    private _notificationService: NotificationService, private datepipe: DatePipe) { this.allData = this.allData.bind(this); }

  ngOnInit() {
    this.project_Id = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getReviewList();
    this.enableMemberRoleFeatures();
  }

  getReviewList() {
    let input = {
      Project_Id: this.project_Id,
      member_Id: this.memberId,
      search_for: "ALL"
    }
    this._peerReviewService.GetReviewList(input).subscribe((data: IReviewListViewModel[]) => {
      this.ReviewList = data;
      this.filter(this.tabname);
    });
  }

  enableMemberRoleFeatures() {
    if (this.project_Id && this.memberId && this.groupId)
      this._commonService.getProjectMemberFeatures(this.project_Id, this.memberId, this.groupId).subscribe((res: any[]) => {
        this.Feature = res;
        this.createicon = this.Feature.some(x => x.feature_Desc == "PR Creation" && x.feature_Id==600001);
      });
  }

  public OnEmit(val: any) {
    this.getReviewList();
  }

  createpeer() {
    let maxCr=0;
    let maxIr=0;
    if(this.ReviewList && this.ReviewList.length>0)
    {
      maxCr = Math.max(...this.ReviewList.filter(x => x.peer_review_type == 'Combined Review (CR)').map(x => x.old_Ref_Id.split('-')).map((x:string[]) => Number(x[1] && x[1].length>0 ? x[1].substring(2,x[1].length) : 0)));
      maxIr = Math.max(...this.ReviewList.filter(x => x.peer_review_type == 'Independent Review (IR)').map(x => x.old_Ref_Id.split('-')).map((x:string[]) => Number(x[1] && x[1].length>0 ? x[1].substring(2,x[1].length) : 0)));
    }
    let dialogRef = this.dialog.open(ReviewCreationComponent,
      {
        panelClass: 'mat-dialog-secondary',
        data:{maxCr:maxCr,maxIr:maxIr},
        width:'100%'
      });
    dialogRef.afterClosed().subscribe(() => {
      this.getReviewList();
    })
  }
  onTabClick(event: any) {
    this.tabname = event.tab.textLabel;
    this.filter(this.tabname);
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }


  filter(tabname: string) {
    this.app_ReviewList = this.ReviewList.filter(x => x.ds_code == 1 || x.ds_code == 2);
    this.invitation_ReviewList = this.ReviewList.filter(x => x.ds_code == 2);
    this.status_ReviewList = this.ReviewList.filter(x => (x.ds_code == 30 || x.ds_code == 32 || x.ds_code == 33 || x.ds_code == 34 || x.ds_code == 35));
    this.comments_ReviewList = this.ReviewList.filter(x => x.ds_code == 35);
    this.responce_ReviewList = this.ReviewList.filter(x => x.ds_code == 32);
    this.impacts_ReviewList = this.ReviewList.filter(x => x.ds_code == 33);
    this.Data = {
      "Feature": this.Feature,
      "tabname": this.tabname,
      "ReviewList": (tabname == 'Approval' ? this.app_ReviewList :
        tabname == 'Invitation' ? this.invitation_ReviewList :
          tabname == 'Status' ? this.status_ReviewList :
            tabname == 'Comments' ? this.comments_ReviewList :
              tabname == 'Response' ? this.responce_ReviewList :
                tabname == 'Impacts' ? this.impacts_ReviewList : this.ReviewList)
    };

  }


  viewPeerdoc(dataItem: any) {
    if (this.memberId) {
      let datainput: DocViewInput =
      {
        strDocNumber: dataItem.requestNo,
        intUID: this.memberId
      };
      this._peerReviewService.getPeerDocView(datainput).subscribe({
        next: (resDoc: DocDetailsOutput) => {
          if (resDoc) {
            let dialogRef = this.dialog.open(ReviewViewComponent,
              {
                panelClass: 'mat-dialog-primary',
                data: { docvalue: resDoc, input: datainput }
              });
            dialogRef.afterClosed().subscribe(() => {
            });
          }
        }, error: () => { }
      });
    }
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.ReviewList
    };
    return result;
  }

  public HelpUrlClick() {
    let x = JSON.parse(this._commonService.getSessionStorageItem("Menu"))
    let url = x.filter((y: { menuDesc: string; }) => y.menuDesc == "Peer Review 4.0")[0].helpUrl
    if (url) { window.open(url); }
  }

}
